<template>
  <div class="calendar-box">
    <div class="left-warp" v-if="activityList.length > 0">
      <div class="header">活动日历</div>
      <el-scrollbar class="c-left-scroll">
        <div class="tag-group">
          <div
            v-for="item in pubAreaList"
            @click="onFilterList(item)"
            :class="activeArea == item ? 'active' : ''"
            :key="item"
          >
            {{ item }}
          </div>
        </div>
        <template v-for="item in activityList">
          <div
            class="c-item"
            :class="item.link_url ? 'has_link' : ''"
            :key="item.id"
            @click="handleLinkUrl(item)"
            v-if="item.isShow"
          >
            <div class="l-bar" :class="item.colorClass"></div>
            <div class="l-cover" v-if="item.picture" @click.stop="imgShow(item.picture)">
              <img :src="item.picture" alt="" />
              <div class="importance" v-if="item.importance">重要</div>
            </div>
            <div class="r-wrapper">
              <div class="item-title">
                {{ item.title }}
              </div>
              <div class="sub-title">
                {{ item.begin_at | dateFormat("MM-DD HH:mm") }} ~
                {{ item.end_at | dateFormat("MM-DD HH:mm") }}
              </div>
            </div>
          </div>
        </template>
      </el-scrollbar>
    </div>

    <div class="left-warp" v-else>
      <div class="header">{{ gameInfo.alias ? "活动日历" : "版主邀请" }}</div>
      <div class="text-box">
        <div class="text" v-if="gameInfo.alias">
          这里是【活动日历】展示区域，这个版主也太懒了吧，竟然连日历都忘了配置。<br />
          您可以帮忙提醒一下版主或管理员吗？连我这个bot都看不下去啦，真的，我哭死！
        </div>
        <template v-else>
          <div class="text">
            欢迎来到游戏专属页面。编辑内容并点击下方的“发帖”按钮即可在社区发帖留言。快来和小伙伴们一起讨论吧。
            游戏版主招募中。诚挚地邀请感兴趣的小伙伴毛遂自荐申请版主，为游戏创建wiki。<br />
            wiki申请简单、免费、零门槛。没有繁琐手续，无需技术基础。可视化编辑器操作简单易上手，相信可以为你的创作助一臂之力。
            点击“申请wiki”按钮，即可进行wiki创建申请，期待你的加入！
          </div>
          <el-button type="primary" @click="showApplyWikiDg">申请wiki</el-button>
        </template>
      </div>
    </div>
    <div class="right-warp">
      <div class="header">{{ nowTime | dateFormat("YYYY年MM月DD日") }}</div>
      <div class="week-group">
        <div v-for="w in weeks" :key="w">{{ w }}</div>
      </div>
      <div class="day-group">
        <div class="week-row" v-for="(weeks, index) in days" :key="index">
          <div class="day-row">
            <div class="day-item" v-for="d in weeks.week" :key="d.day">
              <div class="day">{{ d.day }}</div>
              <div class="game-list">
                <template v-if="d.gameList.length > 0">
                  <el-popover
                    :visible-arrow="false"
                    placement="bottom-start"
                    popper-class="pop-game-group"
                    width="200"
                    :offset="0"
                    trigger="hover"
                  >
                    <template slot="reference">
                      <swiper
                        v-if="d.gameList.length > 1"
                        ref="mySwiper"
                        :auto-destroy="true"
                        :options="swiperOptions"
                        class="swiper-box"
                      >
                        <swiper-slide v-for="game in d.gameList" :key="game.id" class="banner-item">
                          <img
                            @click="goWiki(game)"
                            :src="handleImgSize(game.icon, 'mini')"
                            alt=""
                            class="swiper-lazy"
                          />
                        </swiper-slide>
                      </swiper>
                      <img
                        @click="goWiki(d.gameList[0])"
                        v-else
                        :src="handleImgSize(d.gameList[0].icon, 'mini')"
                        alt=""
                      />
                    </template>
                    <template>
                      <div v-for="game in d.gameList" class="game-item" :key="game.id" @click="goWiki(game)">
                        <img :src="game.icon" alt="" />
                        <div class="r-wrapper">
                          <div class="game-name">{{ game.name }}</div>
                          <div class="sub-title">
                            {{ d.date.unix() | dateFormat("MM月DD日") }}
                            {{ game.area }}上线
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-popover>
                </template>
              </div>
            </div>
          </div>
          <div class="activity-line-group" ref="activityLingGroup">
            <template v-for="(line, index) in weeks.lines">
              <el-tooltip :key="index" placement="top" v-if="index < 4">
                <div slot="content">
                  <div>{{ line.item.title }}</div>
                  <div>
                    活动时间：{{ line.item.begin_at | dateFormat("MM-DD HH:mm") }}
                    ~
                    {{ line.item.end_at | dateFormat("MM-DD HH:mm") }}
                  </div>
                </div>
                <div
                  :style="{
                    width: `${(line.duration * 100) / 7}%`,
                    marginLeft: `${((line.begin - 1) / 7) * 100}%`
                  }"
                  class="line"
                  :class="line.item.colorClass"
                />
              </el-tooltip>
            </template>
          </div>
        </div>
        <div class="line-group">
          <div v-for="i in 7" :key="i"></div>
        </div>
      </div>
    </div>
    <apply-wiki-dg ref="applyWikiDg" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "@/plugins/dayjs";
import { directive, Swiper, SwiperSlide } from "vue-awesome-swiper";
// components
import ApplyWikiDg from "@/views/wiki/components/applyWikiDg.vue";
// apis
import { apiActivityGet, apiOnlineGame } from "@/api/calendarApi";
// plugins
import { getJumpWikiUrl } from "@/plugins/util";

export default {
  name: "calendarBox",
  mixins: [],
  props: {},
  model: {},
  components: {
    Swiper,
    SwiperSlide,
    ApplyWikiDg
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      weeks: ["一", "二", "三", "四", "五", "六", "日"],
      days: [],
      nowTime: dayjs().unix(),
      activityList: [],
      pubAreaList: [],
      activeArea: "全部",
      visible: false,
      swiperOptions: {
        loop: true,
        autoplay: true,
        spaceBetween: 10
      }
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  methods: {
    imgShow(img) {
      this.$imgViewShow([img], 1);
    },
    goWiki(game) {
      const isHasWiki = game.wiki_created_at !== 0;
      const url = getJumpWikiUrl(game.alias, game.id, isHasWiki);
      window.open(url);
    },
    handleLinkUrl(item) {
      if (!item.link_url) return;
      window.open(item.link_url);
    },
    showApplyWikiDg() {
      this.$refs.applyWikiDg.visible = true;
    },
    createDayList() {
      let days = [];
      let now = dayjs();
      // 当周的第一天
      let firstNowWeek = now.startOf("week");
      // 查找上一周，当前周和下一周的日期
      for (let i = -1; i < 2; i++) {
        let weeks = [];
        let first = firstNowWeek.add(i, "week");
        for (let w = 0; w < 7; w++) {
          let d = first.add(w, "day");
          let dayObj = {
            day: d.date(),
            date: d,
            gameList: []
          };
          weeks.push(dayObj);
        }
        let obj = {
          week: weeks,
          lines: []
        };
        days.push(obj);
      }
      this.days = days;
    },
    async getActivityList() {
      let params = {
        start_at: this.days[0].week[0].date.unix(),
        end_at: this.days[2].week[6].date.unix()
      };
      let res = await apiActivityGet(params);
      if (res.code !== 0) return;
      let areaList = [];
      res.data.forEach(item => {
        let index = res.data.indexOf(item);
        item.isShow = true;
        item.pub_area = item.pub_area ? "全部," + item.pub_area : "全部";
        item.colorClass = `c-bar-color-${index % 5}`;
        areaList.push(...item.pub_area.split(","));
      });
      this.pubAreaList = Array.from(new Set(areaList));
      this.activityList = res.data;
      this.createActivityLineBar();
    },
    async getOnlineGameList() {
      let params = {
        start_at: this.days[0].week[0].date.unix(),
        end_at: this.days[2].week[6].date.unix()
      };
      let res = await apiOnlineGame(params);
      if (res.code !== 0) return;
      console.log(res);
      this.days.forEach(weeks => {
        weeks.week.forEach(day => {
          let date = day.date.format("YYYY-MM-DD");
          Object.keys(res.data).forEach(key => {
            let item = res.data[key];
            if (date === key) {
              day.gameList = item;
            }
          });
        });
      });
    },
    onFilterList(area) {
      if (area === this.activeArea) return;
      this.activeArea = area;
      this.activityList.forEach(item => {
        item.isShow = item.pub_area.includes(area);
      });
      this.createActivityLineBar();
    },
    createActivityLineBar() {
      // 清空线条数据
      this.days.forEach(weeks => {
        weeks.lines = [];
      });
      this.activityList.forEach(a => {
        if (!a.isShow) return;
        if (!a.pub_area.includes(this.activeArea)) return;
        if (!a.importance) return;
        this.days.forEach(weeks => {
          //  每周第一天00:00
          let first = weeks.week[0].date.unix();
          // 每周最后一天23:59
          let last = weeks.week[6].date.endOf("day").unix();
          // 活动不在当前周内
          if (a.begin_at > last || a.end_at < first) return;
          a.begin_at_s = dayjs
            .unix(a.begin_at < first ? first : a.begin_at)
            .startOf("day")
            .unix();
          a.end_at_e = dayjs
            .unix(a.end_at > last ? last : a.end_at)
            .endOf("day")
            .unix();

          let a_begin = dayjs.unix(a.begin_at_s).day();
          a_begin = a_begin === 0 ? 7 : a_begin;
          // 持续天数
          let a_duration = dayjs.duration(a.end_at_e - a.begin_at_s, "seconds").asDays();
          let obj = {
            begin: a_begin,
            duration: Math.ceil(a_duration),
            item: a
          };
          weeks.lines.push(obj);
        });
      });
    }
  },
  watch: {},
  async created() {
    // this.createDayList();
    // await this.getActivityList();
    // await this.getOnlineGameList();
  },
  async beforeMount() {
    this.createDayList();
    await this.getActivityList();
    await this.getOnlineGameList();
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>
<style lang="less" scoped>
.calendar-box {
  --left-wrap-width: 254px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  // overflow: hidden;
  padding: 8px;
  border: 2px solid #f0f0f0;
  border-radius: 8px;
  height: 400px;
  margin-bottom: 20px;

  .left-warp {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: var(--left-wrap-width);
  }

  .right-warp {
    width: calc(100% - var(--left-wrap-width) - 16px);
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 0 0 auto;
    width: 100%;
    height: 34px;
    padding: 0 10px;
    background-color: #e3e6ee;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
  }
}

.c-left-scroll {
  flex: 1;
  border-right: 2px solid #f8f8f8;

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .tag-group {
    display: flex;
    align-items: center;
    color: #b8b8b8;
    font-size: 14px;
    position: relative;

    > div {
      padding: 8px 6px;
      cursor: pointer;
      position: relative;

      & + div:before {
        content: "";
        width: 1px;
        height: 10px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #d8d8d8;
      }

      &.active {
        color: #171717;
      }
    }
  }

  .c-item {
    height: 44px;
    margin-bottom: 12px;
    display: flex;

    &.has_link {
      cursor: pointer;
    }

    .l-bar {
      margin-right: 6px;
      width: 4px;
      height: 100%;
    }

    .l-cover {
      width: 70px;
      height: 100%;
      background: #f5f5f5;
      margin-right: 8px;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .importance {
        background: rgba(0, 0, 0, 0.75);
        height: 16px;
        font-size: 10px;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        color: #fff;
        line-height: 1;
        display: flex;
        align-items: center;
        padding: 0 4px;
      }
    }

    .r-wrapper {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .item-title {
        .ellipsis;
        font-size: 13px;
        color: #333;
      }

      .sub-title {
        .ellipsis;
        font-size: 11px;
        color: #7c7c7c;
      }
    }
  }
}

.week-group {
  display: flex;

  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #646464;
    height: 36px;
    font-size: 12px;
  }
}

.day-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .line-group {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    display: flex;
    align-items: stretch;

    div {
      flex: 1;
    }

    div + div {
      border-left: 1px solid #f2f2f2;
    }
  }

  .week-row {
    position: relative;
    z-index: 1;
    flex: auto;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #f2f2f2;

    .day-row {
      display: flex;
    }

    .day-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;

      .day {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #7c7c7c;
        height: 30px;
      }

      .swiper-box,
      .game-list {
        width: 32px;
        height: 32px;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          object-fit: cover;
        }
      }
    }
  }
}

.activity-line-group {
  .line {
    height: 4px;
    margin-top: 4px;
    cursor: pointer;
  }
}

.c-bar-color-0 {
  background: #e6bc3b;
}

.c-bar-color-1 {
  background: #e28888;
}

.c-bar-color-2 {
  background: #68d0f5;
}

.c-bar-color-3 {
  background: #75ae36;
}

.c-bar-color-4 {
  background: #688ff8;
}
</style>
<style lang="less" scoped>
.text-box {
  flex: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  background: #f9f9f9;
  padding: 12px;

  .text {
    font-size: 12px;
    color: #333;
    line-height: 1.8;
  }
}
</style>
<style lang="less">
.pop-game-group {
  background: rgba(0, 0, 0, 0.9);
  border: none;

  .game-item {
    width: 100%;
    display: flex;
    padding-bottom: 8px;
    cursor: pointer;

    &:last-child {
      padding-bottom: 0;
    }

    & + .game-item {
      border-top: 1px solid #444444;
      padding-top: 8px;
    }

    img {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      margin-right: 8px;
    }

    .r-wrapper {
      flex: auto;
      overflow: hidden;

      .game-name {
        .ellipsis;
        font-size: 12px;
        color: #fff;
      }

      .sub-title {
        font-size: 10px;
        color: #acacac;
      }
    }
  }
}
</style>
